import axios from 'axios';

const isProd = process.env.NODE_ENV === 'production';
const defaultBaseUrl = isProd ? '/api' : 'http://localhost:5000/api';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || defaultBaseUrl,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vp_token');
      localStorage.removeItem('vp_faculty');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
